import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Initialize Sentry for error tracking and performance monitoring
import * as Sentry from '@sentry/react';

// Configure Sentry - only initialize if DSN is available
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      // Use the new v8 BrowserTracing integration
      Sentry.browserTracingIntegration(),
      // Automatically capture React rendering errors  
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
      }),
    ],
    // Set traces sample rate to 0.1 for production to capture 10% of transactions for performance
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV || 'production',
    release: 'box-seat-frontend@1.0.0',
    
    // Filter out localhost errors and known noise
    beforeSend(event) {
      // Filter out localhost development errors
      if (event.request?.url?.includes('localhost')) return null;
      
      // Filter out ResizeObserver errors (common browser noise)
      if (event.exception?.values?.[0]?.value?.includes('ResizeObserver loop limit exceeded')) {
        return null;
      }
      
      // Filter out third-party script errors
      if (event.request?.url?.includes('third-party')) return null;
      
      return event;
    },
    
    // Add custom tags for better error organization
    beforeSendTransaction(event) {
      event.tags = { ...event.tags, component: 'frontend' };
      return event;
    },
  });
  console.log('Sentry initialized successfully for frontend error tracking');
} else {
  console.warn('REACT_APP_SENTRY_DSN not found - Sentry not initialized');
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
